export const hdData = [
  {
    type: 0
  },
  {
    type: 1,
    title: '白银会员',
    desc: '小规模招聘',
    color: '#828282',
    hoverDesc: '',
    hoverColor: '#f5a352'
  },
  {
    type: 2,
    title: '黄金会员',
    desc: '中型考试测评',
    color: '#d1ad02',
    hoverDesc: '',
    hoverColor: '#ad6a01'
  },
  {
    type: 3,
    title: '白金会员',
    desc: '大规模选聘',
    color: '#ffde23',
    hoverDesc: '',
    hoverColor: '#009eff'
  },
  {
    type: 4,
    title: '钻石会员',
    desc: '独角兽企业',
    color: '#629bdf',
    hoverDesc: '',
    hoverColor: '#e4bf2b'
  },
  {
    type: 5,
    title: '体验会员',
    desc: 'HR小秘书',
    color: '#b7b7b7',
    hoverDesc: '',
    hoverColor: '#a9aaac'
  }
]

let bdData = [
  { type: 0, value: '100人' },
  { type: 0, value: '企业版' },
  { type: 0, value: '短信：300条,人脸识别：10人' },
  { type: 0, value: '1年' },
  { type: 1 }
].concat(new Array(60).fill({}))
let fixBdData = bdData.map((item, index) => {
  if (index % 2 == 0 && index > 4) {
    return { ...item, type: 1 }
  }
  if (index % 2 != 0 && index > 4) {
    return { ...item, type: 2 }
  } else {
    return item
  }
})
export const newBdData = [fixBdData, fixBdData, fixBdData, fixBdData, fixBdData]



// WEBPACK FOOTER //
// ./src/components/tariff/config.js